import { http } from '@/core/helpers/axiosHelper';
import { WorkClothesType } from './work-clothes-type.interface';

export class WorkClothesTypeService {
   async getWorkClothesTypes() {
      return await http.get<Array<WorkClothesType>>(`/work-clothes-types`).then((response) => response.data);
   }

   async getWorkClothesType() {
      throw Error('Method not implemented');
   }

   async postWorkClothesType() {
      throw Error('Method not implemented');
   }

   async putWorkClothesType() {
      throw Error('Method not implemented');
   }

   async deleteWorkClothesType() {
      throw Error('Method not implemented');
   }
}
